const EXCLUDE_LINE = '无电梯三楼以上每层'

function isElectronicTicketPackageLine(d: any): boolean {
  if (!d) return false
  const f = String(d.dishFlavor || '').trim()
  if (
    f.indexOf('PROMO:') === 0 ||
    f.indexOf('PROMO-GIFT:') === 0 ||
    f.indexOf('WV:') === 0 ||
    f.indexOf('WV-GIFT:') === 0
  ) {
    return true
  }
  const n = String(d.name || '').trim()
  if (n.indexOf('特惠套餐') >= 0 || n.indexOf('实惠套餐') >= 0) return true
  return n.indexOf('电子票') >= 0 && (n.indexOf('特惠') >= 0 || n.indexOf('实惠') >= 0 || n.indexOf('水券') >= 0)
}

function isAdminGiftLine(d: any): boolean {
  return String((d && d.dishFlavor) || '')
    .trim()
    .indexOf('ADMIN-GIFT:') === 0
}

function looksLikeBucketWaterLine(d: any): boolean {
  if (!d) return false
  if (d.bucketWater === true) return true
  if (d.bucketWater === false) return false
  const name = String(d.name || '').trim()
  if (/桶装水|饮用水|矿泉水|纯净水|山泉水|泉水/.test(name)) return true
  return name.includes('桶') && !/空桶/.test(name)
}

/** 是否桶装水配送单（后台不可手动派送/完成，须配送员回单） */
export function isBucketWaterDeliveryOrder(row: any): boolean {
  if (!row) return false
  const t = Number(row.orderType)
  // 普通配送；混合套餐购单含单品上门时也需配送员回单
  if (t === 2) return false
  if (!(t === 1 || t === 3 || t === 4 || !t)) return false
  if (row.requiresEmptyBucketRecord === true) return true
  if (row.requiresEmptyBucketRecord === false) return false
  const used = Number(row.waterBucketsUsed)
  if (Number.isFinite(used) && used > 0) return true
  const details = row.orderDetailList
  if (!Array.isArray(details) || !details.length) return false
  let total = 0
  for (const d of details) {
    if (!d) continue
    if (isElectronicTicketPackageLine(d)) continue
    const name = String(d.name || '').trim()
    if (!name || name === EXCLUDE_LINE) continue
    const adminGift = isAdminGiftLine(d)
    // 后台赠送桶装水带「（赠）」仍需回单；其它随单赠品不计
    if (!adminGift && name.endsWith('（赠）')) continue
    const amount = Number(d.amount)
    if (!adminGift && Number.isFinite(amount) && amount <= 0) continue
    if (adminGift && !looksLikeBucketWaterLine(d)) continue
    total += Math.max(0, Number(d.number) || 0)
  }
  return total > 0
}

/** 下单空桶意图展示 */
export function formatEmptyBucketIntentText(row: any): string {
  if (!row || !isBucketWaterDeliveryOrder(row)) return ''
  if (row.hasEmptyBucket === false) {
    const qty = Math.max(0, Number(row.emptyBucketDepositQty) || 0)
    const amt = Number(row.emptyBucketDepositAmount)
    if (qty > 0 && Number.isFinite(amt) && amt > 0) {
      return `无空桶，押${qty}桶（¥${amt.toFixed(2)}）`
    }
    if (qty > 0) return `无空桶，押${qty}桶`
    return '无空桶'
  }
  if (row.hasEmptyBucket === true) return '有空桶可换，无需押金'
  return ''
}
